import { b as __rest, a as __assign } from '../../../tslib.es6-a39f91fc.js';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { Input } from '../index.js';
import '../../../index-6ea95111.js';
import '../../../index-69a46657.js';
import '../../../style-inject.es-1f59c1d0.js';

var formatInput = function (input) {
    var decimalSeparator = input.includes(',') ? ',' : '.';
    var parts = input.split(decimalSeparator);
    var floor = parts[0];
    var ceiling = parts[1];
    parts[0] = floor.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (ceiling) {
        parts[1] = ceiling.slice(0, Math.min(ceiling.length, 2));
    }
    return parts.join('.');
};
function reverseFormatInput(input) {
    return Number(input.replace(/,/, '.').replace(/\s/g, ''));
}

var CurrencyInput = function (_a) {
    var value = _a.value, onChange = _a.onChange; _a.type; var props = __rest(_a, ["value", "onChange", "type"]);
    var inputRef = useRef(null);
    var _b = useState(null), cursor = _b[0], setCursor = _b[1];
    var _c = useState(''), shadowValue = _c[0], setShadowValue = _c[1];
    var formattedShadowValue = formatInput(shadowValue
        .replace(/ /g, '') // remove all whitespace
        .replace(',', '.') // change commas to dot for decimal separator
        .replace('.', 'DECIMAL_SEPARATOR') // Gymnastic  to remove all the but the first decimal separators 🤸
        .replace(/\./g, '')
        .replace('DECIMAL_SEPARATOR', '.') // End of the Gymnastic 🤸
        .replace(/[^\d\\.]/g, '') // remove all non decimal and dot
    );
    useEffect(function () {
        if (value && value !== reverseFormatInput(shadowValue)) {
            setShadowValue(formatInput(value.toString()));
        }
        // eslint-disable-next-line
    }, [value]);
    useEffect(function () {
        if (shadowValue === '' && value) {
            onChange === null || onChange === void 0 ? void 0 : onChange(0);
        }
        else if (shadowValue) {
            onChange === null || onChange === void 0 ? void 0 : onChange(reverseFormatInput(shadowValue));
        }
        // eslint-disable-next-line
    }, [shadowValue]);
    useEffect(function () {
        if (!inputRef.current || !cursor) {
            return;
        }
        var cursorDiff = String(formattedShadowValue).length - String(shadowValue).length;
        var newCursor = cursorDiff + cursor;
        inputRef.current.selectionStart = newCursor;
        inputRef.current.selectionEnd = newCursor;
    }, [cursor, formattedShadowValue, shadowValue]);
    return (jsx(Input, __assign({ inputMode: 'decimal', prefix: "\u20AC", ref: inputRef, type: "string", value: formattedShadowValue, onChange: function (e) {
            setCursor(e.target.selectionStart);
            setShadowValue(e.target.value);
        } }, props)));
};

export { CurrencyInput };
//# sourceMappingURL=index.js.map
